import React, { useState, useEffect, useRef } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import "../layout/styles/inline-cgos.css";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../service/ChequeCultureService";


export const Dashboard = () => {

  const chequeCultureService = new ChequeCultureService();

  useEffect(() => {
    chequeCultureService.redirectLoginEaLegacy();
  }, []);



  return (
    <div className="grid">
      <ChequeCultureLegacy />
    </div>
  );
};
